// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1w_jN","footer":"Form_footer__1yGUW"};